export default "__VITE_ASSET__BWkwfWOe__"